module.exports = __webpack_public_path__ + "media/images/flags/4x3/mli-26e44660275239471c869ec09d142c04.svg";